import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconDiscard = ({ color = 'var(--icon-red)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1M13 13L1 1" stroke={color} strokeWidth="1.5"/>
        </svg>
    </div>
);

export default IconDiscard;
